import { createPortal } from 'react-dom'
import { Outlet } from 'react-router-dom'

import { usePSNavigate } from '../../../hooks/usePSNavigate'
import { Icon } from '../../Icon'
import Button from '../../app/design/Button'

type AlertPortalrops = React.ComponentPropsWithoutRef<'div'> & {
    header?: React.ReactNode
    footer?: React.ReactNode
    onClose?: () => void
}

const AlertPortal = ({ children, header, footer, onClose, ...props }: AlertPortalrops) => {
    const navigate = usePSNavigate()

    return createPortal(
        <div
            className="fixed inset-0 flex h-screen w-full flex-col bg-gray-100"
            data-testid="page-container"
            {...props}
        >
            <div
                className={`flex-1 overflow-y-auto p-8 ${!header ? 'pt-9' : 'pt-0'}`}
                data-testid="content-container"
            >
                <span className="absolute left-[2.125rem] z-10">{header}</span>
                <Button
                    shape="square"
                    intent="tertiary_deprecated"
                    className="absolute top-[1.125rem] right-[2.125rem] z-10"
                    onClick={() => (onClose ? onClose() : navigate(-1))}
                >
                    <Icon icon="close.large" />
                </Button>
                <main className="max-w-xlarge mx-auto w-full">{children}</main>
            </div>
            {footer}
        </div>,
        document.body
    )
}

export function AlertsRoot() {
    const navigate = usePSNavigate()

    return (
        <AlertPortal onClose={() => navigate('/')}>
            <Outlet />
        </AlertPortal>
    )
}
